import { callToAction } from './callToAction';
import { featuredInMedia } from './featuredInMedia';
import { infiniteCarousel } from './infiniteCarousel';
import { logoSlider } from './logoSlider';
import { ourClients } from './ourClients';
import { partners } from './partners';
import { sponsors } from './sponsors';
import { trustIndex } from './trustIndex';

export const previewItems = {
  callToAction,
  featuredInMedia,
  infiniteCarousel,
  logoSlider,
  ourClients,
  partners,
  sponsors,
  trustIndex
};
